module.exports = new __parcel__URL__("0pa.2fa2a8a3.png").toString();